var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"imagen-galeria"},[_c('img',{staticClass:"cover-img",attrs:{"src":_vm.ruta_imgs,"alt":"tmp"}}),_c('span',{staticClass:"titulo-anio"},[_vm._v(_vm._s(_vm.anio))])])
}
var staticRenderFns = []

export { render, staticRenderFns }